// extracted by mini-css-extract-plugin
export default {"container":"scanPage_container__jupT+"};